export const MOTUL_CLIENT_ID = 8;
export const PRODUCT_MOTUL_IMAGE_LIMIT = 3;
export const PRODUCT_MOTUL_ALLOWED_IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png"];
export const PRODUCT_MOTUL_ALLOWED_IMAGE_MIME_TYPES = ["image/jpeg", "image/png"];
export const PRODUCT_MOTUL_MAX_FILE_SIZE = 5 * 1024 * 1024;
